import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { recuperaPassword } from '../../actions/auth';

const RecuperaPassword = ({ alert, recuperaPassword, isAuthenticated }) => {

    useEffect(() => {
        const size = alert.length;
        if(size>0){
            if(alert[size-1].alertType === "success"){
                setSuccessForm(true)
            }
        }
    }, [alert]);

    const [successForm, setSuccessForm] = useState(false)


    const [formData, setFormData] = useState({
        email: ''
    });


    const { email } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = async e => {
        e.preventDefault();
        recuperaPassword({ email });
    };

    if (isAuthenticated) {
        return <Redirect to="/" />
    }


    return (
        <div id="registrazione-condomino" className="accedi wf-section">
            <div className="container flex-center">
                <div className="form-wrap"><img src="/assets/media/logo.png" loading="lazy" alt="" className="logo"/>
                    <div className="form-block w-form">
                        {successForm ?
                        <div className="container flex-center">
                        <h3 className="no-margin">Controlla la tua email</h3>
                        <p className="m10 center">Abbiamo inviato una email al tuo indirizzo.</p>
                        </div>
                        :
                        <form id="wf-form-login-form" name="wf-form-login-form" data-name="login form" className="form" onSubmit={e => onSubmit(e)}>
                            <h3 id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d03-40413f47" className="no-margin">Inserisci la tua email per recuperare la password</h3>
                            <div id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d0d-40413f47" className="column">
                                <label for="email" className="form-label">Email</label>
                                <input type="text" className="input-field company w-input" maxlength="256" name="email" data-name="email" placeholder="Email" id="email" required="true" value={email} onChange={e => onChange(e)}/>
                            </div>
                            <input type="submit" value="Recupera password" data-wait="Un attimo..." id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d2b-40413f47" className="submit-button w-button"/>
                        </form>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

RecuperaPassword.propTypes = {
    recuperaPassword: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    alert: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    alert: state.alert
});

export default connect(mapStateToProps, { recuperaPassword })(RecuperaPassword);